(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  (function () {
    function loadMore(wrapper) {
      var url = wrapper.dataset.nextUrl;
      var grid = document.getElementById(wrapper.dataset.grid);
      var btn = wrapper.querySelector('[data-load-more-btn]');

      if (!url || !grid || wrapper.classList.contains('is-loading')) return;

      var fetchUrl = url + (url.indexOf('?') >= 0 ? '&' : '?') + 'section_id=' + wrapper.dataset.sectionId;

      wrapper.classList.add('is-loading');
      wrapper.setAttribute('aria-busy', 'true');
      if (btn) btn.disabled = true;

      fetch(fetchUrl)
        .then(function (response) {
          if (!response.ok) throw new Error(response.status);
          return response.text();
        })
        .then(function (html) {
          /* The response is a string, so it has to be turned into nodes before
             we can pick the grid out of it. A <template> is inert - its images
             do not start downloading until the nodes are moved into the live
             document below. */
          var template = document.createElement('template');
          template.innerHTML = html;

          var nextGrid = template.content.querySelector('#' + wrapper.dataset.grid);
          var nextWrapper = template.content.querySelector('[data-load-more]');
          var nextUrl = nextWrapper ? nextWrapper.dataset.nextUrl : '';

          if (nextGrid) grid.append.apply(grid, Array.from(nextGrid.children));

          if (nextUrl) {
            wrapper.dataset.nextUrl = nextUrl;
          } else {
            delete wrapper.dataset.nextUrl;
            if (btn) btn.remove();
          }

          var shownEl = wrapper.querySelector('[data-load-more-shown]');

          /* Direct children only - `highlight-banner` renders a product card of
             its own inside the grid and must not be counted. */
          if (shownEl) shownEl.textContent = grid.querySelectorAll(':scope > .product-card').length;
        })
        .catch(function (error) {
          console.error('Error loading more products:', error);
        })
        .then(function () {
          wrapper.classList.remove('is-loading');
          wrapper.removeAttribute('aria-busy');
          if (btn && btn.isConnected) btn.disabled = false;
        });
    }

    document.addEventListener('click', function (event) {
      var target = event.target;

      if (!target || typeof target.closest !== 'function') return;

      var btn = target.closest('[data-load-more-btn]');

      if (!btn) return;

      event.preventDefault();
      loadMore(btn.closest('[data-load-more]'));
    });
  })();

  } catch(e) { console.error(e); }
})();
})();
